import axios from '../axiosConfig'

import { tokenConfig } from './auth'
import { FETCH_PEDIDO_HABITUAL, GET_PEDIDO_HABITUAL } from './types'

// GET ARTICULOS
export const getPedidoHabitual =
  (domicilio_envio = '', limit = 12) =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_PEDIDO_HABITUAL,
      payload: true,
    })
    axios
      .get(
        `/articulos/habitualCheckout/?domicilio_envio=${domicilio_envio}&limit=${limit}`,
        tokenConfig(getState),
      )
      .then(res => {
        dispatch({
          type: GET_PEDIDO_HABITUAL,
          payload: res.data,
        })
      })
      .catch(err => console.log(err))
  }
